// Centralised time handling for the Sénégal supervisor dashboard.
// Backend timestamps are UTC but some lack a timezone suffix; treat those as UTC,
// then always DISPLAY in the Africa/Dakar timezone.

const DAKAR_TZ = "Africa/Dakar";

export const parseUTC = (iso) => {
  if (!iso) return null;
  let s = String(iso);
  // If there is no timezone designator (Z or ±hh:mm), the backend value is UTC.
  if (!/([zZ]|[+-]\d{2}:?\d{2})$/.test(s)) s += "Z";
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
};

export const formatDakarDate = (iso) => {
  const d = parseUTC(iso);
  if (!d) return "—";
  return d.toLocaleDateString("fr-FR", { timeZone: DAKAR_TZ });
};

export const timeAgo = (iso) => {
  const d = parseUTC(iso);
  if (!d) return "";
  const diff = Math.floor((Date.now() - d.getTime()) / 1000);
  if (diff < 0) return "à l'instant";
  if (diff < 60) return `il y a ${diff}s`;
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  return formatDakarDate(iso);
};

// Full date + time, e.g. "04/10/2026 18:13:40" in Dakar time
export const formatDakar = (iso) => {
  const d = parseUTC(iso);
  if (!d) return "—";
  return d.toLocaleString("fr-FR", {
    timeZone: DAKAR_TZ,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

// Time only (HH:MM:SS) in Dakar time — accepts a Date or ISO string.
export const formatDakarTime = (value) => {
  const d = value instanceof Date ? value : parseUTC(value);
  if (!d) return "";
  return d.toLocaleTimeString("fr-FR", { timeZone: DAKAR_TZ });
};
